import axiosInstance from '../../Config/axiosConfig';
import { notificationsData } from '../../Config/data';
// GET
// export const getNotifications = async (params) => {
//   try {
//     // const data = notificationsData;

//     const response = await axiosInstance.get(`/admin/promocodes`, {
//                 params: requestParams,
//             });

//     // const { data } = await axiosInstance.get('/admin-api/notification', {
//     //   params,
//     // });
//     return data.detail; // Assume this returns the listing object
//   } catch (error) {
//     throw error.response
//       ? error.response.data
//       : { message: 'Unknown error occurred' };
//   }
// };


// export const getNotifications = async (params) => {

    
//   // params agar use karna ho to yahan handle kar sakte ho (pagination, filters etc.)
  
//   // ✅ Direct mock data return
//   return notificationsData.detail;
// };
// //MARK READ
export const editNotification = async (id) => {
    try {
        const response = await axiosInstance.post(
            `/admin/notification/toggle`, {
            uuid: id
        });
        const {
            data: { message, status },
        } = response;
        console.log(message, status, 'message, status');
        return { message, status }; // Assume this returns the success object
    } catch (error) {
        throw error.response
            ? error.response.data
            : { message: 'Unknown error occurred' };
    }
};




// import axiosInstance from '../../Config/axiosConfig';

// Get Notifications
export const getNotifications = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/admin/notification/all/list', {
      params: {
        per_page: params.per_page || 10,
        page: params.page || 1,
        status: params.status || 'all' // all, read, unread
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Mark Notification as Read
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await axiosInstance.post(`/admin/notification/${notificationId}/read`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Mark All Notifications as Read
export const markAllNotificationsAsRead = async () => {
  try {
    const response = await axiosInstance.post('/admin/notification/mark-all-read');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get Unread Notifications Count
export const getUnreadNotificationsCount = async () => {
  try {
    const response = await axiosInstance.get('/admin/notification/unread-count');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};